export default {
  title: {
    en: 'Try 2 or 3 fragrances every month!',
  },
  text: {
    en: `
    Thanks to your input, we’ve improved our upgrade options so that you can now
    try up to three new fragrances each month. With over 500 designer scents for
    you to explore, why not discover even more and still pay less for each one?
  `,
  },
  confirmTitle: {
    en: 'UPGRADE NOW',
  },
  cancelTitle: {
    en: 'MAYBE LATER',
  },
}
